import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface TopProductsProps {
  data: any;
}

export function TopProducts({ data }: TopProductsProps) {
  const topProducts = data.topSellingProducts;

  return (
    <Card className="border-gray-200">
      <CardHeader>
        <CardTitle className="text-lg font-semibold">
          Top Selling Products
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {topProducts.map((product: any, index: number) => (
            <div
              key={product.productid}
              className="flex items-center justify-between"
            >
              <div className="flex items-center space-x-4">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
                  <span className="text-sm font-medium text-primary">
                    #{index + 1}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">
                    {product.productName}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {product.totalQuantity} units sold
                  </p>
                </div>
              </div>
              <Badge variant="default" color="#00C49F" className="ml-2">
                ${product.totalRevenue}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
